export default "__VITE_ASSET__8177DgM0__"